import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule, Table } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ITasksMap } from 'src/app/shared/models/tasks-planned';
import { TaskState } from 'src/app/shared/models/core';
import { MergeTaskStep } from '../merge-task-dialog.component';

@Component({
    selector: 'app-merge-task-table',
    standalone: true,
    imports: [CommonModule, FormsModule, TableModule, CheckboxModule, RadioButtonModule, TagModule, TooltipModule],
    templateUrl: './merge-task-table.component.html',
    styleUrls: ['./merge-task-table.component.scss', '../../../../../shared/css/primeng-table.component.scss']
})
export class MergeTaskTableComponent {
  @Input() routeName = '';
  @Input() tasks: ITasksMap[] = [];
  @Input() loading = false;
  @Input() currentStep: MergeTaskStep;
  @Input() MergeTaskStep = MergeTaskStep;
  @Input() selectionMode: 'multiple' | 'single' = 'multiple';
  @Output() selectionChange = new EventEmitter<ITasksMap[]>();
  @Input() isSelectionDisabled: ((task: ITasksMap) => boolean) | null = null;
  @Input() selectedTasks: any;
  @Input() selectionSummary: ITasksMap[] = [];
  searchText = '';

  @ViewChild('taskTable') taskTable: Table;

  get selectedCount(): number {
    if (Array.isArray(this.selectedTasks)) {
      return this.selectedTasks.length;
    }
    return this.selectedTasks ? 1 : 0;
  }

  onSelectionChange(): void {
    this.selectionChange.emit(this.selectedTasks);
  }

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.taskTable.filterGlobal(value, 'contains');
  }

  clearSearch(): void {
    this.searchText = '';
    this.taskTable.filterGlobal('', 'contains');
  }

  isValidForMerge(task: ITasksMap): boolean {
    return task.task_state !== TaskState.Completed && task.task_state !== TaskState.Failed;
  }

  get allValidForMerge(): boolean {
    return this.tasks.every(t => this.isValidForMerge(t));
  }

  get allSelectedValidForMerge(): boolean {
    if (Array.isArray(this.selectedTasks)) {
      return this.selectedTasks.length > 0 && this.selectedTasks.every(t => this.isValidForMerge(t));
    }
    return this.selectedTasks ? this.isValidForMerge(this.selectedTasks) : false;
  }

  getTaskStateClass(state: string): string {
    switch (state?.toLowerCase()) {
      case 'planned': return 'primary-chip';
      case 'completed': return 'success-chip';
      case 'failed': return 'error-chip';
      case 'closed-merge': return 'error-chip';
      case 'unplanned': return 'warning-chip';
      case 'loaded': return 'warning-chip';
      default: return 'primary-chip';
    }
  }
}
